/**
 * Name of the employee who scheduled the appointment, or '-' when unknown.
 */
export function scheduledByName(appointment) {
    const by = appointment && appointment.createdBy;
    const name = by ? `${by.firstname || ''} ${by.lastname || ''}`.trim() : '';
    return name || '-';
}
